export default function Node_URL() {
  return <div>Node_URL Component</div>;
}
